import request from '../../shared/request'

export function getVehiclesList() {
  return request('/vehicle')
}

export function getScheduledDeliveries(vehicleId) {
  return request(`/scheduled_deliveries/${vehicleId}/vehicle`)
}

export function createVehicle(payload) {
  return request(`/vehicle`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function editVehicle(payload) {
  return request(`/vehicle/${payload.vehicleId}`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function editVehicleStatus(payload) {
  return request(`/vehicle/${payload.vehicleId}/status`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteVehicle(payload) {
  return request(`/vehicle/${payload.vehicleId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/vehicle/${payload.vehicleId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(vehicleId) {
  return request(`/vehicle/${vehicleId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/vehicle/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/vehicle/${payload.attachmentId}/attachment/?vehicleId=${payload.vehicleId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// notes
export function fetchVehicleNote(payload) {
  return request(`/vehicle/${payload.vehicleId}/notes`)
}

export function createVehicleNote(payload) {
  return request(`/vehicle/${payload.vehicleId}/notes`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editVehicleNote(payload) {
  return request(`/vehicle/${payload.noteId}/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteVehicleNote(payload) {
  return request(`/vehicle/${payload.noteId}/notes`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

// followUps
export function fetchVehicleFollowUp(payload) {
  return request(`/vehicle/${payload.vehicleId}/followups`)
}

export function createVehicleFollowUp(payload) {
  return request(`/vehicle/${payload.vehicleId}/followups`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editVehicleFollowUp(payload) {
  return request(`/vehicle/${payload.followUpId}/followups`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteVehicleFollowUp(payload) {
  return request(`/vehicle/${payload.followUpId}/followups`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/vehicle.js